import {
  MarketActivityItem,
  MarketFilter,
  MarketPagination,
  SummaryStat,
} from 'store/market-activity/types';
import {apiMethod, APIService} from '../APIService';

interface ActivityListResult {
  count: number;
  list: MarketActivityItem[];
}

class MarketActivityApi extends APIService {
  fetchSummaryStats = apiMethod<SummaryStat>(
    (filter: MarketFilter) => this.fetcher.request({
      method: 'GET',
      url: `/api/market-activity/summary/`,
      params: {
        ...filter
      }
    }),
  );

  fetchActivityList = apiMethod(
    (filter: MarketFilter, pager: MarketPagination) => this.fetcher.request<ActivityListResult>({
      method: 'GET',
      url: `/api/market-activity/list/`,
      params: {
        ...filter,
        ...pager
      }
    }),
  );

  fetchCityInfo = apiMethod(
    (cityId: number) => this.fetcher.request({
      method: 'GET',
      url: `/api/market-activity/city-info/${cityId}/`,
    })
  );

  // Difference from PartnerAPI, need to create partner request + update market history item by UUID
  addToPartner = apiMethod(
    (userId: number, uuid: string) => this.fetcher.request({
      method: 'GET',
      url: `/api/market-activity/add-partner/`,
      params: {
        userId,
        uuid
      }
    })
  );

  confirmPartner = apiMethod(
    (userId: number, uuid: string) => this.fetcher.request({
      method: 'GET',
      url: `/api/market-activity/confirm-partner/`,
      params: {
        userId,
        uuid
      }
    })
  );
}

export {MarketActivityApi};
